export function parseData(d) {
  const arr = d.split('\r\n').filter(s => !!s);
  const len = arr.length;
  if (len < 2) {
    return [];
  }
  const data = [];
  for (let i = 1; i < len; i += 1) {
    const values = arr[i].split(',');
    const result = {
      id: i,
      logo: values[0],
      name: values[1],
      fee: Number(values[2]),
      address: (values[3]),
      capacity: Number(values[4]),
      cycle: values[5],
      country: values[6],
      website: values[7],
      efficiency: -1,
      currentCapacity: -1,
      monthlyEfficiency: -1,
      roi: -1,
    };
    data.push(result);
  }
  return data;
}

export function parseBlackList(d) {
  const arr = d.split('\r\n').filter(s => !!s);
  const len = arr.length;
  if (len < 2) {
    return [];
  }
  const data = [];
  for (let i = 1; i < len; i += 1) {
    const values = arr[i].split(',');
    const result = {
      rank: i,
      logo: values[0],
      name: values[1],
      address: values[2],
      country: values[3],
      index: values[4],
    };
    data.push(result);
  }
  return data;
}

export function formatPercent(d, f) {
  const fixed = f || 0;
  return `${(d * 100).toFixed(fixed)}%`;
}

export function formatCycle(c) {
  switch (c) {
    case '1':
      return 'Daily';
    case '2':
      return 'Weekly';
    case '3':
      return 'Monthly';
    case '4':
      return 'Yearly';
    default:
      return '';
  }
}
